import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import {
  Container,
  Dimmer,
  Loader
} from 'semantic-ui-react'
import qs from 'query-string'
import { autoLogin } from '../../action/user'
import { DISPLAY_MODE } from '../../constant'
import { AutoLoginParams } from '../../../types'
import './autoLogin.css'

type AutoLoginProps = {
  location: { search: string }
  autoLogin: (params: AutoLoginParams) => void
}

function AutoLogin(
  props: AutoLoginProps
): JSX.Element {
  const { location, autoLogin: autoLoginAction } = props
  const params = qs.parse(location.search, { ignoreQueryPrefix: true }) as unknown as AutoLoginParams

  useEffect(() => {
    autoLoginAction(params)
  }, [])

  const mode = params.embedded && params.embedded === 'true'
    ? DISPLAY_MODE.EMBEDDED
    : DISPLAY_MODE.SMART

  if (mode === DISPLAY_MODE.EMBEDDED) {
    // if display mode is embedded, skip the friendly text
    return (
      <Container>
        <Dimmer active inverted>
          <Loader className="autologin-loader" size="big" />
        </Dimmer>
      </Container>
    )
  }

  return (
    <Container>
      <Dimmer active inverted>
        <Loader className="autologin-loader" size="big">
          <div className="autologin-header">Hang Tight!</div>
          <div className="autologin-content">We are logging you in.</div>
        </Loader>
      </Dimmer>
    </Container>
  )
}

export default connect(
  () => ({}),
  { autoLogin }
)(AutoLogin)
